/**
 * Flatten filter object into query parameter format
 * Converts: { filters: { column_id: [value1, value2] } }
 * Into: { 'filters[column_id][]': [value1, value2] }
 */
export const normalizeFilterParams = (
  filterParams: Record<string, any>,
): Record<string, any> => {
  const normalized: Record<string, any> = {};

  Object.entries(filterParams).forEach(([key, value]) => {
    if (key === "filters" && typeof value === "object" && value !== null) {
      // Convert nested filters object into bracket notation
      Object.entries(value).forEach(([filterKey, filterValue]) => {
        if (Array.isArray(filterValue)) {
          normalized[`filters[${filterKey}][]`] = filterValue;
        } else {
          normalized[`filters[${filterKey}]`] = filterValue;
        }
      });
    } else {
      normalized[key] = value;
    }
  });

  return normalized;
};
